import script from "./PersonEditComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonEditComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__